import { action } from 'typesafe-actions'
import { Client } from '@models/client'
import {RequestData} from "@models/axios";

export const enum ClientsActionTypes {
    FETCH_REQUEST = '@@cliens/FETCH_REQUEST',
    FETCH_SUCCESS = '@@cliens/FETCH_SUCCESS',
    FETCH_ERROR = '@@cliens/FETCH_ERROR',
}



export const fetchRequest = (data:RequestData) => action(ClientsActionTypes.FETCH_REQUEST, data);
export const fetchSuccess = (data: Client[]) => action(ClientsActionTypes.FETCH_SUCCESS, data);
export const fetchError = (message: string) => action(ClientsActionTypes.FETCH_ERROR, message);
